import './controls.css'

export default function Controls(){  

    // console.log(position==new Vector3(4, 0, 1));
    // console.log(position);

    // const panel_style = {
    //     "lineHeight": "20px",
    //     position: "absolute",
    //     top: "5%",
    //     left: "80%",
    //     width: "15%",
    //     // color: "#703f00",
    //     color: "black",

    //     backgroundColor: "#fad7b2",
    //     borderRadius: "10px",
    //     border: "solid black 5px",
    // }
    // return <div style={panel_style}>
    return <div className="controls">
        {/* <h1>Controls:</h1> */}
        <h3>Show both hands to the camera to drive the car</h3>
        <h3>
            Accelerate: 👊👊
        </h3>
        <h3>
            Brake: 🖐🖐
        </h3>
        <h3>
            Left: &nbsp;
            <div className="hand-one">👊</div>
            <div className="hand-two">👊</div>
        </h3>
        <h3>
            Right: &nbsp;
            <div className="hand-three">👊</div>
            <div className="hand-four">👊</div>
        </h3>
        {/* <h3>
            Restart: ✌
        </h3>
        <h3>
            Upload your time: ✌✌
        </h3> */}
        <p className="warning-message">(Refresh the page if the car does not move)</p>
    </div>
}